module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/node_modules/core-js/internals/hidden-keys.js
// module id = wGVZ
// module chunks = 0